/*
 * @Author: your name
 * @Date: 2021-06-24 13:50:56
 * @LastEditTime: 2021-06-24 13:50:57
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /HR_FE/src/store/getters.js
 */
const getters = {
  tag: state => state.tags.tag,
  language: state => state.common.language,
  website: state => state.common.website,
  userInfo: state => state.user.userInfo,
  userAllInfo: state => state.user.userAllInfo,
  colorName: state => state.common.colorName,
  themeName: state => state.common.themeName,
  isShade: state => state.common.isShade,
  isCollapse: state => state.common.isCollapse,
  keyCollapse: (_state, _getters) => (_getters.screen > 1 ? _getters.isCollapse : false),
  screen: state => state.common.screen,
  isLock: state => state.common.isLock,
  isFullScren: state => state.common.isFullScren,
  isMenu: state => state.common.isMenu,
  lockPasswd: state => state.common.lockPasswd,
  tagList: state => state.tags.tagList,
  tagWel: state => state.tags.tagWel,
  token: state => state.user.token,
  roles: state => state.user.roles,
  permission: state => state.user.permission,
  menu: state => state.user.menu,
  dicts: state => state.user.dicts,
  menuId: state => state.user.menuId,
  menuAll: state => state.user.menuAll,
  logsList: state => state.logs.logsList,
  logsLen: state => state.logs.logsList.length || 0,
  logsFlag: (_state, _getters) => _getters.logsLen === 0,
  flowRoutes: state => state.dict.flowRoutes,
  staticRouter: state => state.common.staticRouter,
  isInitPasswordFlag: state => state.user.isInitPasswordFlag,
  tempUserInfo: state => state.user.tempUserInfo,
  templateForm: state => state.user.templateForm,
  recentlyUser: state => state.common.recentlyUser,
  dictsStaticData: state => state.user.dicts,
  aiisToken: state => state.user.aiisToken,
  noticeProcessParams: state => state.user.noticeProcessParams,
  courseList: state => state.user.courseList,
}
export default getters
